import { render } from "./achieversView.vue?vue&type=template&id=011c29c3"
import script from "./achieversView.vue?vue&type=script&lang=js"
export * from "./achieversView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__